import { ADVICE_NAMES, Advice } from "Store/advice/interfaces";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { OneTimePaymentAdvisorChoice } from "../../ProductPrice/AdviceCards/interfaces";
import { AkaAdvicePriceFormValues } from "../../ProductPriceAka/AkaAdviceCards/interfaces";

export interface AdviceProductBaseValues {
  isStayingInNorwayForMoreThanFiveYears?: boolean;
  dateOfBirth?: string;
  workSituation: WorkSituation;
  education?: Education;
  familySituation: FamilySituation;
  debtResponsible?: DebtResponsible;
  disabilityPension?: DisabilityPension;
  economicalSituation: EconomicalSituation;
  economicalHealthWish: EconomicalHealthWish;
  situationComment?: string;
}

export interface AdviceProductDetailsFormValues
  extends AdviceProductBaseValues {
  income: number;
  debt: number;
  childDatesOfBirth?: ChildDateOfBirth[];
  isExpectingChildren?: BooleanFormType;
  incomeDependency?: BooleanFormType;
  addCoInsured?: BooleanFormType;
  coInsuredBirthDate?: Date;
}

export interface AdviceProductDetailsBackendValues
  extends AdviceProductBaseValues {
  income: number;
  debt: number;
  childDatesOfBirth?: string[] | number[][];
  isExpectingChildren?: boolean;
  incomeDependency?: boolean;
  addCoInsured?: boolean;
  coInsuredBirthDate?: string | number[];
  isAdvisor?: boolean;
  advisorValues?: AdvisorValues;
}

export enum AdviceDocumentType {
  ADVICE_RECOMMENDED = "ADVICE_RECOMMENDED",
  ADVICE_CHOSEN = "ADVICE_CHOSEN",
  ADVICE_ORDERED = "ADVICE_ORDERED",
}

export interface CartAdviceValues {
  adviceProductValues: AdviceProductDetailsBackendValues;
  adviceInitialRequest: AdviceData[];
  adviceChangedByCustomer?: AdviceData[];
  adviceProducts?: AdviceProduct[];
  adviceDocumentId?: string;
  adviceDocumentType?: AdviceDocumentType;
}

export interface AkaCartAdviceValues {
  adviceProductValues: AdviceProductDetailsBackendValues;
  finalAkaAdviceData: AkaAdvicePriceFormValues;
  adviceProducts?: AdviceProduct[];
  adviceDocumentId?: string;
  adviceDocumentType?: AdviceDocumentType;
}

export interface ChangedByCustomer {
  insuranceAdvices: Advice;
  cartAdviceValues: CartAdviceValues;
  isAdvisor: boolean;
}

export interface AdviceData {
  insuranceName: ADVICE_NAMES;
  productCheckedToPurchase: boolean;
  sliderValue: number;
  insuranceMonthlyPrice?: number;
  additionalData?: DisabilityAdditionalData;
}

export interface DisabilityAdditionalData {
  disabilityOneTimePaymentChecked?: boolean;
  disabilityOneTimePaymentValue?: number;

  disabilityPaymentAfter3Months?: boolean;
  disabilityOneTimePaymentChoice?: OneTimePaymentAdvisorChoice;
  disabilityOneTimePaymentAdvisorValue?: number;
}

export interface AdviceProduct {
  productId: string;
  insuranceName: string;
}

export interface AdvisorValues {
  situationComment?: string;
  adviceComment?: string;
  disabilityPaymentAfter3Months?: boolean;
  disabilityOneTimePaymentAdvisorChoice?: OneTimePaymentAdvisorChoice;
  disabilityOneTimePaymentAdvisorValue?: number;
}

export enum WorkSituation {
  WORK_PRIVATE = "workPrivate",
  WORK_PUBLIC = "workPublic",
  SELF_EMPLOYED = "selfEmployed",
  FULL_TIME_STUDENT = "fullTimeStudent",
  SICK_LEAVE = "sickLeave",
  UNEMPLOYED = "unemployed",
  NOT_WORKING = "notWorking",
  PENSIONER = "pensioner",
}

export enum Education {
  HIGH_SCHOOL_PLUS_5_YEARS = "highSchoolPlus5Years",
  HIGH_SCHOOL_PLUS_3_YEARS = "highSchoolPlus3Years",
  HIGH_SCHOOL = "highSchool",
  NOT_HIGH_SCHOOL = "notHighSchool",
}

export enum FamilySituation {
  MARRIED = "married",
  COHABITANT = "cohabitant",
  SINGLE = "single",
}

export interface ChildDateOfBirth {
  id: string;
  dateOfBirth: string;
  inputFieldTouched?: boolean;
  inputFieldError?: boolean;
}

export enum DebtResponsible {
  BOTH = "both",
  ME_ALONE = "meAlone",
  SPOUSE_COHABITANT_ALONE = "spouseCohabitantAlone",
}

export enum DisabilityPension {
  NO = "no",
  YES = "yes",
  DO_NOT_KNOW = "doNotKnow",
}

export enum EconomicalSituation {
  SPACIOUS = "spacious",
  JUST_RIGHT = "justRight",
  TIGHT = "tight",
}

export enum EconomicalHealthWish {
  FINANCES_LIKE_TODAY = "financesLikeToday",
  SLIGHT_ECONOMIC_DOWNTURN = "slightEconomicDownturn",
  SIGNIFICANT_ECONOMIC_DOWNTURN = "significantEconomicDownturn",
}
